module.exports = __webpack_public_path__ + "img/logo.56fe0d14.svg";